import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Time Off list (CLAUDE.md §2.3),
 * mirroring the CRM/Employees list stores. Search/status/type filters live in
 * URL-bound page state and stay out of the store — those are server-driven
 * query params, not durable user prefs.
 */
export type TimeOffViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const TIME_OFF_VIEW_MODES: TimeOffViewMode[] = [
  'table',
  'list',
  'cards',
  'grouped',
];

interface TimeOffUiState {
  view: TimeOffViewMode;
  setView: (view: TimeOffViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-start_date`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useTimeOffUi = create<TimeOffUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'hrm.time-off:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
